var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutoRenewalDisabled = function SvgAutoRenewalDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a7.99 7.99 0 0 0-8 8c0 4.427 3.573 8 8 8s8-3.573 8-8-3.573-8-8-8Zm4.107 9.747-2.36-3.387h1.493c-.44-.773-1.147-1.4-1.987-1.707a3.725 3.725 0 0 0-4.773 2.2c-.373.934-.307 1.96.093 2.854a3.6 3.6 0 0 0 2.08 1.92c.4.16.627.586.467.986-.093.307-.4.494-.72.494a.717.717 0 0 1-.28-.067c-1.307-.467-2.36-1.453-2.947-2.733a5.21 5.21 0 0 1-.16-4.027C6 5.547 9.04 4.16 11.773 5.173a5.388 5.388 0 0 1 3.134 3.16h1.306l-2.12 3.387.014.027Z",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.458.775.775 17.458l1.767 1.767L19.226 2.542 17.457.775Z",
    fill: "#999"
  })));
};
export default SvgAutoRenewalDisabled;